import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromAppRoot from '@app/app.reducers';
import * as fromStrategy from '@strategy/reducers';

import { BOND_LIST, MOBILE_VIEW_TRESHOLD } from '@app/app.constants';
import { CustomerInvestmentData } from '@shared/models/Strategy';
import { ThirdPartyServiceItem } from '@shared/models/ThirdPartService';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-strategy-3a-portfolio',
  templateUrl: './strategy-3a-portfolio.component.html',
  styleUrls: ['./strategy-3a-portfolio.component.scss'],
  standalone: false
})
export class Strategy3APortfolioComponent implements OnDestroy, OnInit {
  protected readonly onDestroy$ = new Subject<void>();
  @Output() updateTab = new EventEmitter<number>();
  @Input() step: number;

  customer: Customer;
  currentAccount: CustomerAccount;
  changeStrategyDisabled = false;
  flipperBookConsultation$: Observable<ThirdPartyServiceItem>;
  investmentData: CustomerInvestmentData;
  mobileView = false;
  discardedWishes: string[];
  seenDiscardedWishes: { modalOpened: boolean; redirectUrl: string; discardedWishesDialog: boolean };
  showStrategyChanges = '';
  bondList = BOND_LIST;
  bookConsultation = false;
  showScroll = false;
  scroll = 0;

  constructor(
    private store: Store,
    public router: Router,
    private trackingService: TrackingService
  ) {
    this.mobileView = window.innerWidth < MOBILE_VIEW_TRESHOLD;

    this.store
      .pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount), takeUntil(this.onDestroy$))
      .subscribe(({ customer, currentAccountDetail }) => {
        this.customer = customer;
        this.currentAccount = currentAccountDetail;
      });

    this.store.pipe(select(fromStrategy.selectCustomerInvestmentData), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.investmentData = response;
    });

    this.store.pipe(select(fromStrategy.selectChangeStrategyDisabled), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.changeStrategyDisabled = response;
    });

    this.store.pipe(select(fromStrategy.selectCustomerDiscardedWish), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.discardedWishes = value;
    });

    this.store.pipe(select(fromStrategy.selectDiscardedWishesDialog), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.seenDiscardedWishes = value;
    });

    this.flipperBookConsultation$ = this.store.select(
      fromAppRoot.selectThirdPartyServices('show_book_consultation')
    ) as Observable<ThirdPartyServiceItem>;
  }

  ngOnInit(): void {
    this.trackingService.trackView('/portfolio');
  }

  changeStrategy(): void {
    if (this.changeStrategyDisabled === false) {
      void this.router.navigate(['/strategy/adjust']);
    }
  }

  bookModal(value: boolean): void {
    this.bookConsultation = value;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  saveStrategy(type: string): void {
    this.showStrategyChanges = type;

    setTimeout(() => {
      this.showStrategyChanges = '';
    }, 3200);

    if (type === 'discard') {
      this.store.dispatch(StrategyActions.discardStrategyChanges());
      this.trackingService.trackActivity('Frontend: Strategy change discarded', true);
    } else {
      this.store.dispatch(StrategyActions.saveStrategyChanges());
      this.trackingService.trackActivity('Frontend: Strategy change saved', true);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: Window }): void {
    if (event.target.innerWidth >= MOBILE_VIEW_TRESHOLD) {
      this.mobileView = false;
    } else {
      this.mobileView = true;
    }
  }

  scrollTop(): void {
    this.trackingService.trackActivity('[Button] Strategy portfolio: scroll back to top');
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:scroll') watchScroll() {
    if (this.showScroll === false) {
      if (window.scrollY < this.scroll) {
        this.showScroll = true;
      } else {
        this.scroll = window.scrollY;
      }
    }

    if (window.scrollY < 300) {
      this.showScroll = false;
    }
  }
}
